import React, { useState } from "react";
import { FaTerminal, FaCode, FaGraduationCap, FaLaptopCode, FaBrain } from "react-icons/fa";
import "./About.css";

export default function About() {
  const [currentDirectory] = useState("~/about");

  return (
    <section id="about" className="about-section">
      <div className="terminal-window">
        <div className="terminal-bar">
          <div className="terminal-buttons">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="terminal-title">
            <FaTerminal /> about.md — {currentDirectory}
          </div>
        </div>

        <div className="terminal-content">
          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="command">cat about.md</span>
          </div>

          <div className="about-content">
            <div className="section-title">
              <FaCode /> Technical Background
            </div>
            <p>
              I am a passionate Computer Science student with a strong foundation in software development
              and a keen interest in cutting-edge technologies. My expertise spans across full-stack development,
              AI/ML engineering, and system design, allowing me to tackle complex technical challenges
              with innovative solutions.
            </p>

            <div className="section-title">
              <FaGraduationCap /> Education Journey
            </div>
            <p>
              Currently pursuing my Bachelor's in Computer Science, I've maintained a strong academic record
              while actively engaging in practical projects. My coursework has equipped me with both theoretical
              knowledge and hands-on experience in various aspects of computer science.
            </p>

            <div className="section-title">
              <FaLaptopCode /> Technical Interests
            </div>
            <p>
              I'm particularly interested in:
              <ul>
                <li>Full Stack Development with modern frameworks and technologies</li>
                <li>Artificial Intelligence and Machine Learning applications</li>
                <li>Distributed Systems and Cloud Architecture</li>
                <li>System Design and Scalable Solutions</li>
              </ul>
            </p>

            <div className="section-title">
              <FaBrain /> Learning Philosophy
            </div>
            <p>
              I believe in continuous learning and staying updated with the latest technological advancements.
              My approach combines theoretical understanding with practical implementation, always striving
              to create efficient and scalable solutions.
            </p>
          </div>

          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="cursor">|</span>
          </div>
        </div>
      </div>
    </section>
  );
} 